// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-p_ge","advertDetailServiceList__header":"c-p_gf","advertDetailServiceList__list":"c-p_gg"};